<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div *ngFor="let item of taskDatumMap | keyvalue: noSort">
  <div [ngSwitch]="item.value['type']">
    <div class="output_properties" *ngSwitchCase="TaskDatumType.STRING" fxLayout="column">
      <span class="task_properties_title">{{ item.key }}</span>
      <app-string-item [stringItem]="item.value" class="output-item"></app-string-item>
    </div>
    <div class="output_properties" *ngSwitchCase="TaskDatumType.TIMESTAMP_ISO" fxLayout="column">
      <span class="task_properties_title">{{ item.key }}</span>
      <app-timestamp-item [timestampItem]="item.value" class="output-item"></app-timestamp-item>
    </div>
    <div class="output_properties" *ngSwitchCase="TaskDatumType.BOOL" fxLayout="column">
      <span class="task_properties_title">{{ item.key }}</span>
      <app-boolean-item [booleanItem]="item.value" class="output-item"></app-boolean-item>
    </div>
    <div class="output_properties" *ngSwitchCase="TaskDatumType.INT" fxLayout="column">
      <span class="task_properties_title">{{ item.key }}</span>
      <app-int-item [intItem]="item.value" class="output-item"></app-int-item>
    </div>
    <div class="output_properties" *ngSwitchCase="TaskDatumType.DOUBLE" fxLayout="column">
      <span class="task_properties_title">{{ item.key }}</span>
      <app-double-item [doubleItem]="item.value" class="output-item"></app-double-item>
    </div>
    <div class="output_properties" *ngSwitchCase="TaskDatumType.ARRAY" fxLayout="column">
      <span class="task_properties_title">{{ item.key }}</span>
      <app-array-item
        [arrayItem]="item.value"
        class="output-item"
        fxFlex="calc(100%-180px)"
      ></app-array-item>
    </div>
    <div class="output_properties" *ngSwitchCase="TaskDatumType.OBJECT" fxLayout="column">
      <span class="task_properties_title">{{ item.key }}</span>
      <app-object-item [objectItem]="item.value" class="output-item"></app-object-item>
    </div>
    <div class="output_properties" *ngSwitchCase="TaskDatumType.SIGNATURE" fxLayout="column">
      <span class="task_properties_title">{{ item.key }}</span>
      <app-signature-item [signatureItem]="item.value" class="output-item"></app-signature-item>
    </div>
    <div class="output_properties" *ngSwitchCase="TaskDatumType.IMAGE_PNG" fxLayout="column">
      <span class="task_properties_title">{{ item.key }}</span>
      <app-image-item [imageItem]="item.value" class="output-item"></app-image-item>
    </div>
    <div class="output_properties" *ngSwitchCase="TaskDatumType.IMAGE_JPEG" fxLayout="column">
      <span class="task_properties_title">{{ item.key }}</span>
      <app-image-item [imageItem]="item.value" class="output-item"></app-image-item>
    </div>
    <div class="output_properties" *ngSwitchCase="TaskDatumType.IMAGE_URL" fxLayout="column">
      <span class="task_properties_title">{{ item.key }}</span>
      <app-image-url-item [imageItem]="item.value" class="output-item"></app-image-url-item>
    </div>
  </div>
</div>
